<div id="loading-view" ng-controller="loginController as ctrl">
    <div class="wrapper">
        <div class="content">
            <div class="logo_text"></div>
            <div class="login-wrapper">
                <p id="progress-info" ng-if="ctrl.loggingIn">{{ctrl.progress|translate}}</p>
                <div c-loader ng-if="ctrl.loggingIn"></div>
                <div ng-if="ctrl.usingAuthentication(ctrl.modes.forms) || ctrl.usingAuthentication(ctrl.modes.mixedMode)">
                    <form class="login-form" ng-submit="ctrl.login()" ng-if="!ctrl.loggingIn">
                        <p><label class="username-display" ng-if="ctrl.hasUser" ng-dblclick="ctrl.changeUser()">{{ctrl.user.displayName}}</label></p>
                        <input type="text" name="UserName" id="username" ng-if="!ctrl.hasUser" ng-model="ctrl.user.userName" placeholder="{{'loginName'|translate}}" />
                        <input type="{{ctrl.inputType}}" name="Password" id="password" ng-if="!ctrl.user.trusted" ng-model="ctrl.password" autocomplete="off" placeholder="{{'password'|translate}}" />
                        <i id="eyeicon" class="{{ctrl.showHideClass}}" ng-if="!ctrl.user.trusted" ng-click="ctrl.showPassword()"></i>
                        <select ng-if="ctrl.domainVisible" ng-model="ctrl.domain" ng-options="d for d in ctrl.domains">
                            <option value="">{{'undefinedDomain'|translate}}</option>
                        </select>
                        <button class="login-button" type="submit" ng-if="!ctrl.user.trusted">{{'logon'|translate}}</button>
                        <button class="login-button-trusted" type="button" ng-if="ctrl.user.trusted" ng-click="ctrl.useWindowsAccount()">{{'logon'|translate}}</button>
                    </form>
                    <div id="change-user" ng-if="!ctrl.loggingIn && ctrl.hasUser">
                        <a ng-click="ctrl.changeUser()">{{'changeUser'|translate}}</a>
                    </div>
                </div>

                <div id="use-windows-account" ng-if="!ctrl.loggingIn &&
                     (ctrl.usingAuthentication(ctrl.modes.windowsLowSecurity) ||
                     ctrl.usingAuthentication(ctrl.modes.windowsHighSecurity) ||
                     ctrl.usingAuthentication(ctrl.modes.mixedMode))">
                    <a ng-click="ctrl.useWindowsAccount()">{{'useWindowsAccount'|translate}}</a>
                </div>
                <div id="use-guest-account" ng-if="ctrl.canSignInAsGuest && !ctrl.loggingIn">
                    <a ng-click="ctrl.useGuestAccount()">{{'useGuestAccount'|translate}}</a>
                </div>
                <div id="forgot_password" ng-if="!ctrl.loggingIn &&
                     (ctrl.usingAuthentication(ctrl.modes.mixedMode) ||
                     ctrl.usingAuthentication(ctrl.modes.forms))">
                    <a ng-click="ctrl.forgotPassword()">{{'forgotPassword'|translate}}</a>
                </div>

                <div ng-if="ctrl.usingAuthentication(ctrl.modes.saml)">
                    <form class="login-form" ng-submit="ctrl.loginSaml()" ng-if="!ctrl.loggingIn">
                        <p><label class="saml-providers" data-translate="choose.saml.provider"></label></p>
                        <select id="provider" ng-model="ctrl.provider" ng-options="provider.text for provider in ctrl.providers track by provider.id"></select>
                        <button class="login-button" type="submit">{{'logon'|translate}}</button>
                    </form>
                </div>
                <div class="error">{{ctrl.error|translate}}</div>
            </div>
        </div>
    </div>
</div>
